import LottieAnimation from "../core/LottieAnimation";
import ResizableScene from "../core/ResizableScene";
import ScaleManager from "../core/ScaleManager";
import ActionQueue from "../utils/ActionQueue";
import Overlay from "../utils/Overlay";

export default class ScreenTransition extends Phaser.GameObjects.Container {

    scene: ResizableScene;
    animation: SpineGameObject;
    start: boolean;
    overlay: Overlay;
    container: SpineContainer;
    animationDuration: number;
    onTweenComplete: () => void;

    constructor(scene: ResizableScene, start: boolean, onTweenComplete?: () => void) {
        super(scene);
        scene.add.existing(this);
        this.depth = 999;
        this.onTweenComplete = onTweenComplete;
        scene.game.input.enabled = false;
        const overlay = this.overlay = Overlay.create(scene, 1);
        overlay.tint = 0xd2362f;
        this.add(overlay);
        scene.alignIn.Center(overlay, scene.viewport);
        this.start = start;

        const transition = this.animation = scene.add.spine(0, 0, "screen-transition", start ? "intro" : "outro");
        const spineContainer = this.container = scene.add.spineContainer(0, 0);
        this.add(spineContainer);
        spineContainer.add(transition);
        this.animationDuration = this.animation.getCurrentAnimation().duration;
        
        scene.alignIn.Center(spineContainer, scene.viewport);

        transition.once("complete", () =>{
            if(onTweenComplete) onTweenComplete();
            // only need to handle destroying this on "outro" anim since closing the preloader scene cleans this up
            if(!start) {
                transition.destroy();
                this.destroy();
            }
        });

        // if(start){
        //     transition.play("intro", false);
        //     // this.scene.tweens.add({
        //     //     targets: this.overlay, 
        //     //     alpha: {from: 0, to: 1},
        //     //     duration: 300, 
        //     //     ease: Phaser.Math.Easing.Linear,
        //     // });
        //     transition.on("complete", () =>{
        //         transition.play("middle", false);
        //         if(onTweenComplete) onTweenComplete();
        //         transition.destroy();
        //         this.destroy();
        //     });
        // }else{
        //     transition.play("outro", false);

        //     // const startingTime = this.animationDuration / 2;
        //     // this.animation.state.tracks[0].trackTime = startingTime;
        //     // this.animation.play("animation");
        //     // this.animation.timeScale = 1;
        //     transition.on("complete", (): void => {
        //     // this.scene.tweens.add({
        //     //     targets: this.overlay, 
        //     //     delay: 300,
        //     //     alpha: {from: 1, to: 0},
        //     //     duration: 500, 
        //     //     ease: Phaser.Math.Easing.Linear
        //     // });
        //     if (onTweenComplete) onTweenComplete();
        //     transition.destroy();
        //     this.destroy();
        // });
        // }

        //scene.events.on(Phaser.Scenes.Events.UPDATE, this.update, this);

    }

    // update(dt: number): void{
    //     super.update(dt);
    //     if(this.start){
    //         if(this.animation.timeScale != 0 && this.start){
    //             const currAnimationTime = this.animation.state.tracks[0].getAnimationTime();
    //             if(currAnimationTime >= (this.animationDuration / 2)){
    //                 console.log("PAUSE ANIMATION");
    //                 this.animation.timeScale = 0;
    //                 if(this.onTweenComplete) this.onTweenComplete();
    //                 this.animation.destroy();
    //                 this.destroy();
    //             }
    //         }

    //     }
    // }

    public static to(from: ResizableScene, to: string, data?: Record<string, unknown>, onMidpoint?: () => any): void {
        const queue = new ActionQueue();

        queue.add(complete => {
            new ScreenTransition(from, true, complete);
        });

        queue.add(complete => {
            if (onMidpoint) onMidpoint();
            from.scene.start(to, data);
            const destScene = from.scene.get(to) as ResizableScene;
            destScene.game.events.once(Phaser.Scenes.Events.CREATE, (): void => {
                new ScreenTransition(destScene, false, complete);
            });
        });

        queue.add(() => {
            from.game.input.enabled = true;
        });

        queue.start();
    }

    public static enter(from: ResizableScene, onMidpoint?: () => any): void {
        const queue = new ActionQueue();

        let transition: ScreenTransition;
        queue.add(complete => {
            transition = new ScreenTransition(from, true, complete);
        });

        queue.add(complete => {
            if (onMidpoint) onMidpoint();
            transition.destroy();
            complete();
        });

        queue.start();
    }

    public static exit(scene: ResizableScene): void {
        const queue = new ActionQueue();

        queue.add(complete => {
            new ScreenTransition(scene, false, complete);
        });

        queue.add(() => {
            scene.game.input.enabled = true;
        });

        queue.start();
    }
}
